import { render } from "./CreateTicket.vue?vue&type=template&id=17cf751c&scoped=true"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"

import "./CreateTicket.vue?vue&type=style&index=0&id=17cf751c&lang=scss&scoped=true"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17cf751c"]])

export default __exports__